import React from 'react';
import PropTypes from 'prop-types';

function UserIcon({ color = 'black', width = 14, height = 19, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 19"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.332031 18.3335C0.332031 16.5654 1.03441 14.8697 2.28465 13.6195C3.53489 12.3692 5.23059 11.6668 6.9987 11.6668C8.76681 11.6668 10.4625 12.3692 11.7127 13.6195C12.963 14.8697 13.6654 16.5654 13.6654 18.3335H11.9987C11.9987 17.0074 11.4719 15.7356 10.5342 14.798C9.59655 13.8603 8.32478 13.3335 6.9987 13.3335C5.67262 13.3335 4.40085 13.8603 3.46316 14.798C2.52548 15.7356 1.9987 17.0074 1.9987 18.3335H0.332031ZM6.9987 10.8335C4.2362 10.8335 1.9987 8.596 1.9987 5.8335C1.9987 3.071 4.2362 0.833496 6.9987 0.833496C9.7612 0.833496 11.9987 3.071 11.9987 5.8335C11.9987 8.596 9.7612 10.8335 6.9987 10.8335ZM6.9987 9.16683C8.84036 9.16683 10.332 7.67516 10.332 5.8335C10.332 3.99183 8.84036 2.50016 6.9987 2.50016C5.15703 2.50016 3.66536 3.99183 3.66536 5.8335C3.66536 7.67516 5.15703 9.16683 6.9987 9.16683Z"
        fill={color}
      />
    </svg>
  );
}

UserIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default UserIcon;
